import { Badge, Table } from '@radix-ui/themes'
import type { TRPCOutputs } from '~/utils/trpc'
import { stageColor, stageLabel } from '~/features/installations/constants'
import { computeStage } from '~/features/installations/service'
import { CellText } from '~/components/CellText'
import { InstallationIdentityCells, InstallationIdentityHeaders } from './InstallationIdentityCells'

type Installation = TRPCOutputs['ops']['stationInstallations']['list'][number]

interface InstallationRetiredTableProps {
  installations: Installation[]
  onRowClick: (installationId: number) => void
}

// Who retired it is deliberately absent: that lives on the installation's own timeline, and
// joining the event here would cost a query per row to save one click.
export const InstallationRetiredTable = ({ installations, onRowClick }: InstallationRetiredTableProps) => (
  <Table.Root variant="surface">
    <Table.Header>
      <Table.Row>
        <InstallationIdentityHeaders />
        <Table.ColumnHeaderCell>Retired on</Table.ColumnHeaderCell>
        <Table.ColumnHeaderCell>Reason</Table.ColumnHeaderCell>
        <Table.ColumnHeaderCell>Stage reached</Table.ColumnHeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {installations.map((row) => {
        const stage = computeStage(row)
        return (
          <Table.Row
            key={row.installation_id}
            onClick={() => onRowClick(row.installation_id)}
            className="cursor-pointer text-[var(--gray-11)] hover:bg-[var(--gray-a2)]"
          >
            <InstallationIdentityCells installation={row} />
            <Table.Cell>
              <CellText value={row.retired_at} />
            </Table.Cell>
            <Table.Cell>
              <CellText value={row.retirement_reason} />
            </Table.Cell>
            <Table.Cell>
              <Badge color={stageColor[stage]} variant="soft" size="1">
                {stageLabel[stage]}
              </Badge>
            </Table.Cell>
          </Table.Row>
        )
      })}
    </Table.Body>
  </Table.Root>
)
